(function($){
	// Handle the mobile menu toggling
	$('.menu .menu-toggle a').click(function(e) {
		e.preventDefault();

		mainNav();
	});

	function mainNav() {
		$('#main').toggleClass('menu-open');
	}

	//Handle blog switching
	$('#blog_dropdown').change(function(e) {
		let url = $(this).val();


		if (url && url.length) {
			window.location = url;
		}
	});
})(jQuery);
